const multiSelectionComplications = {
    paddingBottom: "3%",
    width: "90%"
}

const multiSelectionAlignInput = {
    textAlignLast: "left"
}

export { multiSelectionComplications, multiSelectionAlignInput };